import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Pagination.css';

const Pagination = ({ page, totalPages, onPageChange, className = '' }) => {
  if (totalPages <= 1) return null;

  const show = 5;
  let start = Math.max(1, page - Math.floor(show / 2));
  let end = Math.min(totalPages, start + show - 1);
  if (end - start + 1 < show) start = Math.max(1, end - show + 1);

  const nums = [];
  for (let i = start; i <= end; i++) nums.push(i);

  return (
    <div className={`tb-pagination ${className}`}>
      <button className="tb-pg-btn" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        <FaChevronLeft />
      </button>

      {start > 1 && (
        <>
          <button className="tb-pg-num" onClick={() => onPageChange(1)}>1</button>
          {start > 2 && <span className="tb-pg-dots">...</span>}
        </>
      )}

      {nums.map(n => (
        <button
          key={n}
          className={`tb-pg-num ${n === page ? 'tb-pg-num--on' : ''}`}
          onClick={() => onPageChange(n)}
        >
          {n}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="tb-pg-dots">...</span>}
          <button className="tb-pg-num" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
        </>
      )}

      <button className="tb-pg-btn" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
        <FaChevronRight />
      </button>

      <span className="tb-pg-info">Page {page} of {totalPages}</span>
    </div>
  );
};

export default Pagination;
